import React from 'react';
import { ChatArchive } from 'generated/api';
import { ReduxChatMessage } from 'careand-redux/slices/chat';

interface ChatContextProps {
  messages: Record<string, ReduxChatMessage[]>;
  unreadMessages: Record<string, number>;
  joinedRooms: ChatArchive[];
  unreadCount: number;
  // Ephemeral "Carey is doing X…" status per chatId (null/absent when idle).
  careyActivity?: Record<string, string | null>;

  clearCareyActivity?(chatId: string): void;

  sendMessage?: () => void;

  markMessagesRead?(name: string): void;

  leaveRoom?(room: string): void;
}

const ChatContext = React.createContext<ChatContextProps>({
  messages: {},
  unreadMessages: {},
  joinedRooms: [],
  unreadCount: 0,
});

export default ChatContext;
